module.exports = __webpack_public_path__ + "images/943767a9350d4e153bcbed1d8b00a99e-hero-banner1.png";